import React, { FC, useContext } from 'react';
import { CreateEditEstimateNavEnum } from 'containers/estimates/constants';
import { CreateEstimateContext } from '../CreateEstimate';
import SignatureOptionsSection from './SignatureOptionsSection';
import EstimateReferenceNumber from './EstimateReferenceNumber';
import EstimateLeadSource from './EstimateLeadSource';

interface CreateEstimateMoreOptionsProps {
  className?: string;
}

const CreateEstimateMoreOptions: FC<CreateEstimateMoreOptionsProps> = () => {
  const { selectedEstimateTab } = useContext(CreateEstimateContext);

  const isTabSelected = selectedEstimateTab === CreateEditEstimateNavEnum.MORE_OPTIONS;

  return (
    <div>
      <div className={`mb-2 text-xl font-bold ${isTabSelected ? 'text-primaryBtn' : 'text-heading'}`}>More options</div>
      <div
        className={`flex flex-col space-y-5 rounded-md border px-8 py-6
                    ${isTabSelected ? 'border-primaryBtn' : 'border-borderGray'}`}>
        <SignatureOptionsSection />
        <EstimateReferenceNumber />
        <EstimateLeadSource />
      </div>
    </div>
  );
};

export default CreateEstimateMoreOptions;
